import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { AddressLifeCycleStatus } from '../../enums/AddressLifeCycleStatus.js';
import { AddressType } from '../../enums/AddressType.js';
import { ContactPointStatus } from '../../enums/ContactPointStatus.js';
export class PartyAddressDetails extends BaseMessage {
    addressLifeCycleStatus;
    contactPointStatus;
    postalAddressType;
    addressLines;
    countryCode;
    postCode;
    type;
    residentialStatusCode;
    residentialStatusDescription;
}
__decorate([
    Field.enum({
        enum: AddressLifeCycleStatus,
        description: 'The address is Previous, Current or Future',
        required: true,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "addressLifeCycleStatus", void 0);
__decorate([
    Field.enum({
        enum: ContactPointStatus,
        description: 'The current status of the Address',
        required: true,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "contactPointStatus", void 0);
__decorate([
    Field.enum({
        enum: AddressType,
        description: 'Type of address',
        required: true,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "postalAddressType", void 0);
__decorate([
    Field.array({
        items: {
            type: 'string',
            example: 'LEEDS',
        },
        required: true,
        description: 'Address Lines',
    }),
    __metadata("design:type", Array)
], PartyAddressDetails.prototype, "addressLines", void 0);
__decorate([
    Field.string({
        description: 'Code of the country. Will be the country of Residence for Individual',
        required: true,
        maxLength: 3,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "countryCode", void 0);
__decorate([
    Field.string({
        description: 'UK Postal Code',
        required: true,
        maxLength: 8,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "postCode", void 0);
__decorate([
    Field.string({
        description: 'This is used to identify the type of contact point.',
        required: true,
        maxLength: 30,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "type", void 0);
__decorate([
    Field.number({
        required: true,
        maximum: 14,
        minimum: 0,
        description: 'Holds the Code value of the residency status',
        numberType: 'integer',
    }),
    __metadata("design:type", Number)
], PartyAddressDetails.prototype, "residentialStatusCode", void 0);
__decorate([
    Field.string({
        description: 'Holds the Code value of the residency status',
        required: true,
        maxLength: 30,
    }),
    __metadata("design:type", String)
], PartyAddressDetails.prototype, "residentialStatusDescription", void 0);
//# sourceMappingURL=PartyAddressDetails.js.map